import {
  Box,
  Button,
  Card,
  CardBody,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datePickerStyles.css";
import { ChevronDownIcon } from "@chakra-ui/icons";

const CalendarComponent = ({
  callbackFunctionDate,
  triggerSetter = null,
  scaling = false,
  date,
  height = "40px",
  swap = false,
  left,
  mt=0
}) => {
  const [endDate, setEndDate] = useState(date);
  const [showPicker, setShowPicker] = useState(false);
  const [currentDate, setCurrentDate] = useState(date);
  const datePickerRef = useRef();

  const handleDateSelection = (date) => {
    const selectedDate = new Date(date);
    const lastDayOfMonth = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth() + 1,
      0
    );
    setEndDate(lastDayOfMonth);
  };

  const handleClickOutside = (event) => {
    if (
      datePickerRef.current &&
      !datePickerRef.current.contains(event.target)
    ) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSave = () => {
    callbackFunctionDate(endDate);
    triggerSetter && triggerSetter(true);
    setCurrentDate(endDate);
    setShowPicker(false);
  };

  const formatDisplayDates = () => {
    if (currentDate instanceof Date && !isNaN(currentDate)) {
      return `${currentDate.toLocaleDateString("en-US", {
        month: "short",
        year: "numeric",
      })}`;
    } else {
      return "";
    }
  };

  return (
    <Box ref={datePickerRef} position="relative">
      <InputGroup
        width={scaling ? "100%" : "130px"}
        minWidth={"100px"}
        maxW={"150px"}
        textAlign={"center"}
        ml={scaling ? 0 : 6}
        backgroundColor={"white"}
        borderRadius={"12px"}
      >
        <Input
          cursor={"pointer"}
          height={height}
          fontSize={"16px"}
          readOnly
          value={formatDisplayDates()}
          onClick={() => setShowPicker((prev) => !prev)}
        />
        <InputRightElement
          height="100%" // Matches the height of the input
          display="flex"
          alignItems="center" // Vertically centers the icon
          pointerEvents="none"
        >
          <ChevronDownIcon boxSize={4} mr={2} />
        </InputRightElement>
      </InputGroup>
      {showPicker && (
        <Card
          textAlign={"right"}
          p={0}
          zIndex={9999}
          width="290px"
          position="absolute"
          right={!swap && "0"}
          left={swap && ( left ? left : "0")}
          top="100%"
          backgroundColor="white"
          boxShadow="md"
          mt={mt}
        >
          <CardBody p={1}>
            <Box>
              <DatePicker
                selected={endDate}
                onChange={handleDateSelection}
                endDate={endDate}
                inline
                showMonthYearPicker
                dateFormat="MM/yyyy"
              />
              <Button
                m={"6px 9px 10px"}
                height={"32px"}
                width={"81px"}
                backgroundColor="#536DEC"
                textColor={"white"}
                onClick={handleSave}
              >
                Save
              </Button>
            </Box>
          </CardBody>
        </Card>
      )}
    </Box>
  );
};

export default CalendarComponent;
